import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { UserRole } from '../types/user';
import { useAuth } from './AuthContext';

interface ProtectedRouteProps {
  allowedRoles?: readonly UserRole[];
  children: ReactNode;
}

function ProtectedRoute({ allowedRoles, children }: ProtectedRouteProps) {
  const { currentUser, isAuthenticated, isLoading, hasRole } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <div className="dashboard-route-status" role="status">Loading account...</div>;
  }

  if (!isAuthenticated || !currentUser) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!hasRole(allowedRoles)) {
    return (
      <section className="dashboard-page">
        <div className="dashboard-empty-state">
          <p className="eyebrow">Access restricted</p>
          <h1>{currentUser.name} does not have access to this workspace.</h1>
          <p>Contact an administrator if this account should manage users or dashboard settings.</p>
        </div>
      </section>
    );
  }

  return <>{children}</>;
}

export default ProtectedRoute;
